import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { "mute-secondary": "" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_ctx.business)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("small", _hoisted_2, _toDisplayString(_ctx.$filters.capitalize(_ctx.business.name)), 1)
      ]))
    : _createCommentVNode("", true)
}